import { render, staticRenderFns } from "./productsSliderItem.vue?vue&type=template&id=f78c7a1c"
import script from "./productsSliderItem.vue?vue&type=script&lang=js"
export * from "./productsSliderItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports